import { useState, useEffect } from "react";
import {
  LeftCircleOutlined,
  LoadingOutlined,
  PlusCircleOutlined,
  StopOutlined
} from "@ant-design/icons";
import { Button, Col, Descriptions, Form, Modal, Row, Select, notification } from "antd";
import {
  useCancelVisitMutation,
  useCreateCustomerConnectLogForVisitMutation,
  useGetCustomerConnectLogsForVisitQuery,
  useLazyGetVisitByIdQuery,
  useOnHoldVisitMutation,
  useUpdateCustomerConnectLogForVisitMutation
} from "../../../redux/services/visitApi";
import { useAppSelector } from "../../../redux/hooks";
import ConnectLogTabel from "../ConnectLogTabel";
import { useNavigate, useParams } from "react-router-dom";
import ConnectLogForm from "../ConnectLogForm";
import ErrorDetails from "../../../components/ErrorDetails";
import { localizeDateTime, localizeDate, customerAddress, getStatusText } from "../../../utils";
import { holdOptions, cancelComplaintOptions } from "../../../constants/helperConstants";

const ViewVisit = (props: any) => {
  const navigate = useNavigate();
  const params = useParams();

  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();

  const visitId = params?.visitId;
  const [getVisitById, { data, isLoading, refetch: refetchGetVisitById }] = useLazyGetVisitByIdQuery();;
  const visit = data?.visit;

  const { data: customerConnectLogs, refetch: refetchCustomerConnectLogs } =
    useGetCustomerConnectLogsForVisitQuery(visitId);

  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setEditMode] = useState(false);
  const [selectedCallLogData, setSelectedCallLogData] = useState({});
  const [showFullView, setShowFullView] = useState(false);

  const [onCreateCustomerConnectLogForVisit] = useCreateCustomerConnectLogForVisitMutation();
  const [onUpdateCustomerConnectLogForVisit] = useUpdateCustomerConnectLogForVisitMutation();

  const [cancel] = useCancelVisitMutation();

  const [onHold] = useOnHoldVisitMutation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");

  const user = useAppSelector<any>((store) => store.auth.user);

  const isClient = user?.user_type === "client";

  useEffect(() => {
    if (visitId) {
      getVisitById(visitId);
    }
  }, [visitId])


  const onGoBack = () => {
    navigate(-1);
  };

  const onAddCallLog = async (values: object, setLoading: any, form: any) => {
    try {
      setLoading(true);
      await onCreateCustomerConnectLogForVisit(values).unwrap();
      api.success({
        message: "Call log created for visit",
        placement: "top"
      });
      form.resetFields();
      refetchCustomerConnectLogs();
      setLoading(false);
      setShowModal(false);
    } catch (error: any) {
      api.info({
        message: "Create call log for visit operation failed",
        description: <ErrorDetails errors={error?.data || []} />,
        placement: "top"
      });
      setLoading(false);
    }
  };

  const onUpdateCallLog = async (values: object, setLoading: any, form: any) => {
    try {
      setLoading(true);
      await onUpdateCustomerConnectLogForVisit(values).unwrap();
      api.success({
        message: "Call log updated for visit",
        placement: "top"
      });
      form.resetFields();
      refetchCustomerConnectLogs();
      setLoading(false);
      setShowModal(false);
    } catch (error: any) {
      api.info({
        message: "Update call log for visit operation failed",
        description: <ErrorDetails errors={error?.data || []} />,
        placement: "top"
      });
      setLoading(false);
    }
  };

  const onUpdateCallLogModal = (callLog: any) => {
    setSelectedCallLogData(callLog);
    setEditMode(true);
    setShowModal(true);
  };

  const onUpdate = (callLog: any) => {
    setSelectedCallLogData(callLog);
    setEditMode(true);
    setShowModal(true);
  };

  const handleCancelOrHold = (type: string) => {
    setModalType(type);
    setIsModalOpen(true);
  };

  const onFinish = async (values: any) => {
    if (modalType === "HOLD") {
      try {
        await onHold({ id: visitId, reason: values.reason }).unwrap();
        api.success({
          message: "Visit marked as on hold operation successful",
          placement: "top"
        });
        form.resetFields();
        refetchGetVisitById();
        setIsModalOpen(false);
      } catch (error: any) {
        api.info({
          message: "Visit marked as on hold operation failed",
          description: <ErrorDetails errors={error?.data || []} />,
          placement: "top"
        });
      }
    }

    if (modalType === "CANCEL") {
      try {
        await cancel({ id: visitId, reason: values.cancel_reason }).unwrap();
        api.success({
          message: "Visit cancelled successfully",
          placement: "top"
        });
        form.resetFields();
        refetchGetVisitById();
        setIsModalOpen(false);
      } catch (error: any) {
        api.info({
          message: "Visit cancelled operation failed",
          description: <ErrorDetails errors={error?.data || []} />,
          placement: "top"
        });
      }
    }
  };

  const handleCancel = () => {
    setModalType("");
    setIsModalOpen(false);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <>
      {contextHolder}
      {!isLoading && data && (
        <div style={{ paddingBottom: 50 }}>
          <Row style={{ marginBottom: 20 }}>
            <Col
              sm={24}
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
              <h2>Visit Details</h2>
              <Button onClick={onGoBack} size="middle" type="default" icon={<LeftCircleOutlined />}>
                Back
              </Button>
            </Col>
          </Row>
          {!isClient && (
            <Row style={{ marginBottom: 20 }}>
              <Col
                sm={24}
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                <div></div>
                <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
                  {data?.visit?.status && data?.visit?.status !== "completed" && (
                    <>
                      <Button icon={<StopOutlined />} onClick={() => handleCancelOrHold("CANCEL")}>
                        Cancel
                      </Button>
                      {/* <Button
                      icon={<PauseCircleOutlined />}
                      onClick={() => handleCancelOrHold("HOLD")}
                    >
                      Hold
                    </Button> */}
                    </>
                  )}
                  <Button icon={<PlusCircleOutlined />} onClick={() => setShowModal(true)}>
                    Create Visit Log
                  </Button>
                </div>
              </Col>
            </Row>
          )}

          <Descriptions
            title=""
            bordered
            column={1}
            labelStyle={{ fontWeight: 700, width: 250 }}
            size="middle"
          >
            <Descriptions.Item label="Visit Code">
              {data?.visit?.ecb_visit_code || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Charger Type">{data?.visit?.obc || "-"}</Descriptions.Item>
          </Descriptions>
          <br />

          <h3>Customer Details</h3>

          <Descriptions
            title=""
            bordered
            column={1}
            labelStyle={{ fontWeight: 700, width: 250 }}
            size="middle"
          >
            <Descriptions.Item label="Customer">
              {data?.visit?.customer_name || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
              {data?.visit?.contact_number || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Booking Address">
              {data?.visit?.booking_address || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Address">{customerAddress(data?.visit)}</Descriptions.Item>
            <Descriptions.Item label="EV City">{data?.visit?.city?.name || "-"}</Descriptions.Item>
            <Descriptions.Item label="Customer Rating">
              {data?.visit?.customer_rating ? `${data?.visit?.customer_rating}/5` : "-"}
            </Descriptions.Item>
          </Descriptions>

          <h3>Timelines</h3>

          <Descriptions
            title=""
            bordered
            column={1}
            labelStyle={{ fontWeight: 700, width: 250 }}
            size="middle"
          >
            <Descriptions.Item label="Status">
              {getStatusText(data?.visit)}
              {data?.visit?.status && data?.visit?.status === "cancelled" && (
                <>
                  <p style={{ margin: 0 }}>
                    Time: {localizeDateTime(data?.visit?.cancelled_at) || ""}
                  </p>
                  <p style={{ margin: 0 }}>Reason: {data?.visit?.cancel_reason || ""}</p>
                </>
              )}
              {data?.visit?.status && data?.visit?.status === "on_hold" && (
                <>
                  <p style={{ margin: 0 }}>Reason: {data?.visit?.on_hold_reason || ""}</p>
                </>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Scheduled Date - Time">
              {data?.visit?.scheduled_visit_date_time
                ? localizeDateTime(data?.visit?.scheduled_visit_date_time)
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Complaint Receive Date">
              {data?.visit?.complaint_receive_date
                ? localizeDate(data?.visit?.complaint_receive_date)
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Brand Booking Date">
              {data?.visit?.brand_booking_date
                ? localizeDate(data?.visit?.brand_booking_date)
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="eCB Receive Date">
              {data?.visit?.ecb_receive_date ? localizeDate(data?.visit?.ecb_receive_date) : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="eCB Booking Date">
              {data?.visit?.ecb_booking_date ? localizeDate(data?.visit?.ecb_booking_date) : "-"}
            </Descriptions.Item>
            <br />

            <Descriptions.Item label="First Contact">
              {data?.visit?.first_contact_at || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Created At">
              {data?.visit?.created_at ? localizeDateTime(data?.visit?.created_at) : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Next Follow Up">
              {data?.visit?.next_follow_up_at
                ? localizeDateTime(data?.visit?.next_follow_up_at)
                : "-"}
            </Descriptions.Item>
            <br />
            <br />
            <Descriptions.Item label="Start Time">
              {data?.visit?.actual_visit_date_time
                ? localizeDateTime(data?.visit?.actual_visit_date_time)
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="End Time">
              {data?.visit?.visit_completed_at
                ? localizeDateTime(data?.visit?.visit_completed_at)
                : "-"}
            </Descriptions.Item>
          </Descriptions>

          <h3>Team</h3>

          <Descriptions
            title=""
            bordered
            column={1}
            labelStyle={{ fontWeight: 700, width: 250 }}
            size="middle"
          >
            <Descriptions.Item label="City Manager">
              {data?.visit?.assigned_city_manager?.name || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Fied Agent">
              {data?.visit?.assigned_field_agent1?.name || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Partner">
              {data?.visit?.visit_partner?.name || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Partner Mgr.">
              {data?.visit?.assigned_partner_user?.name || "-"}
            </Descriptions.Item>
          </Descriptions>

          <h3>Vehicle Details</h3>

          <Descriptions
            title=""
            bordered
            column={1}
            labelStyle={{ fontWeight: 700, width: 250 }}
            size="middle"
          >
            <Descriptions.Item label="Dealer">{data?.visit?.dealer_name || "-"}</Descriptions.Item>

            <Descriptions.Item label="Brand Model">
              {data?.visit?.brand_model?.name || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Model Color">
              {data?.visit?.model_colour || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Brand Complaint Number">
              {data?.visit?.brand_complaint_number || "-"}
            </Descriptions.Item>
          </Descriptions>

          {!showFullView && (
            <Button type="link" onClick={() => setShowFullView(true)} style={{ marginTop: "20px" }}>
              Show More
            </Button>
          )}

          {showFullView && (
            <>
              <br />
              <Descriptions
                title=""
                bordered
                column={1}
                labelStyle={{ fontWeight: 700, width: 250 }}
                size="middle"
              >
                <Descriptions.Item label="Brand Booking Code">
                  {data?.visit?.brand_booking_code || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Dealer Location">
                  {data?.visit?.dealer_location || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Booking Address">
                  {data?.visit?.booking_address || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Cust. Alt. Contact">
                  {data?.visit?.alt_contact_number || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Record - Cust. Ok?">
                  {data?.visit?.customer_ok_with_recording ? "YES" : "NO"}
                </Descriptions.Item>

                <br />

                <Descriptions.Item label="Model Description">
                  {data?.visit?.model_description || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Model Name">
                  {data?.visit?.complaint_brand_model_name || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="VIN Number">{data?.visit?.vin || "-"}</Descriptions.Item>
                <Descriptions.Item label="Variant">
                  {data?.visit?.model_variant || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Int Color">
                  {data?.visit?.model_int_color || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Ext Color">
                  {data?.visit?.model_ext_color || "-"}
                </Descriptions.Item>

                <br />

                <Descriptions.Item label="Latitude">
                  {data?.visit?.latitude || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Longitude">
                  {data?.visit?.longitude || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Outstation">
                  {data?.visit?.is_outstation ? "YES" : "NO"}
                </Descriptions.Item>

                <Descriptions.Item label="Site POC Name">
                  {data?.visit?.site_poc_name || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Site POC Contact">
                  {data?.visit?.site_poc_contact || "-"}
                </Descriptions.Item>

                <br />

                <Descriptions.Item label="Cable Length">
                  {data?.visit?.cable_length_new || data?.visit?.cable_length || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Cable Gauge">
                  {data?.visit?.cable_gauge || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Charger Capacity">
                  {data?.visit?.charger_capacity || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Charger Make">
                  {data?.visit?.charger_make_type || "-"}
                </Descriptions.Item>

                <br />

                <Descriptions.Item label="Extra Cable">
                  {data?.visit?.extra_cable_customer_pay ? "Yes" : "No"}
                </Descriptions.Item>

                <Descriptions.Item label="MDI">{data?.visit?.mdi || "-"}</Descriptions.Item>
                <Descriptions.Item label="VDC">{data?.visit?.vdc || "-"}</Descriptions.Item>
                <Descriptions.Item label="Sanctioned Load">
                  {data?.visit?.sanctioned_load || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Average Load Utilised">
                  {data?.visit?.avg_load_utilized || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Note for Agent">
                  {data?.visit?.agent_notes || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Broad Visit Findings 1">
                  {data?.visit?.summary_stage1 || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Broad Visit Findings 2">
                  {data?.visit?.summary_stage2 || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Remarks">{data?.visit?.remarks || "-"}</Descriptions.Item>

                <br />

                <Descriptions.Item label="Company Name">
                  {data?.visit?.company_name || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="GST">{data?.visit?.gst || "-"}</Descriptions.Item>

                <Descriptions.Item label="Flag">{data?.visit?.flag || "-"}</Descriptions.Item>
              </Descriptions>
            </>
          )}
          {showFullView && (
            <Button
              type="link"
              onClick={() => setShowFullView(false)}
              style={{ marginTop: "20px" }}
            >
              Show Less
            </Button>
          )}
          <ConnectLogTabel
            title="Visit customer connect logs"
            data={customerConnectLogs?.customer_connect_logs || []}
            msil={data?.visit?.brand?.send_reports_to_api}
            onUpdate={onUpdate}
            onUpdateCallLogModal={onUpdateCallLogModal}
          />
        </div>
      )}
      {isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh"
          }}
        >
          <LoadingOutlined style={{ fontSize: 24 }} spin />
        </div>
      )}

      {showModal && (
        <ConnectLogForm
          assignment={visit}
          title={isEditMode ? "Update customer connect logs" : "Create customer connect logs"}
          isOpen={showModal}
          msil={data?.visit?.brand?.send_reports_to_api}
          nextFollowUpRequired={data?.visit?.brand?.next_follow_up_required}
          handleCancel={() => {
            setShowModal(false);
            setEditMode(false);
          }}
          isEditMode={isEditMode}
          onAddCallLog={!isEditMode && onAddCallLog}
          onUpdateCallLog={isEditMode && onUpdateCallLog}
          selectedCallLogData={isEditMode && selectedCallLogData}
          booking
        />
      )}

      <>
        <Modal
          title={`${modalType === "HOLD" ? "Put Visit on Hold" : "Cancel Visit"}`}
          open={isModalOpen}
          onCancel={handleCancel}
          footer={[
            <Button key="cancel" onClick={handleCancel}>
              Cancel
            </Button>,
            <Button form="myForm" key="submit" htmlType="submit" type="primary">
              Submit
            </Button>
          ]}
        >
          <Form
            name="myForm"
            form={form}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            style={{ maxWidth: 600 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label={modalType === "HOLD" ? "Reason for puting on hold" : "Reason for cancel"}
              name="cancel_reason"
              rules={[{ required: true, message: "Please input reason!" }]}
            >
              <Select
                placeholder="Select status"
                optionFilterProp="children"
                showSearch
                filterOption={(inputValue, option: any) =>
                  option.label.toLowerCase().includes(inputValue.toLowerCase())
                }
                options={modalType === "HOLD" ? holdOptions : cancelComplaintOptions}
              ></Select>
            </Form.Item>
          </Form>
        </Modal>
      </>
    </>
  );
};

export default ViewVisit;
